import { Component , Vue } from 'vue-property-decorator';
import { COURSE_MATERIAL_AUDIO_FILES_TYPES, COURSE_MATERIAL_VIDEO_FILES_TYPES, COURSE_MODE } from '@/courses/values/courses.values';
import { SectionsProvider } from '@/content/providers/sections.provider';
import ToolService from '@/providers/tools';
import KEYS from '@/values/keys';
import { COURSES_EVENTS } from '../values/courses-events.values';
import { COURSE_EVENTS } from '@/content/values/events';
import { SECTION_TYPES, TYPE_BOARD_DRAFT_RESPONSE_OPTIONS, TYPE_TEXT_DRAFT_RESPONSE_OPTIONS } from '@/content/values/sections';
import { COMPONENT_TYPE } from '@/courses/values/courses.values'
import Course from '@/content/models/course.model';
import { Section } from '../models/section.model';
import { IparamsComponentSelected } from '@/courses/interfaces/params-component-selected';
import { _APP_STORE } from '@/core/values/app.values';
import EdMembersConnected from '@/core/components/ed-members-connected/ed-members-connected.component.vue';
import { IParamsSetTeacherPosition } from '../interfaces/params-set-teacher-position.interface';
import { MEETINGS_STORE } from '@/meetings/store/meetings.store';
import { Project } from '../models/project.model';
import { ACTIVE_TRANSPARENCY_EVENT, INACTIVE_TRANSPARENCY_EVENT } from '@/content/values/ed-presentation-mode.values';
import { HOMEWORKS_STORE } from '@/homework/store/homeworks.store';
import { ICreateObjectParans } from '../interfaces/course-tools.interface';

@Component({
  components: {
    EdMembersConnected
  }
})
export class CourseToolsMixin extends Vue {

  private componentName: string = COMPONENT_TYPE.OBJECT_PREVIEW.code;

  get isPresentationModeTeacher(){
    return this.$store.state.CourseStore.isPresentationTeacherMode;
  }

  get isTransparencyManually() : boolean {
    return this.$store.state.MeetingsStore.isTransparencyManually;
  }

  get isWhiteboardTransparency() : boolean {
    return this.$store.state.MeetingsStore.isWhiteboardTransparency;
  }

  get currentBoardUser(): any {
    return this.$store.state.MeetingsStore.currentBoardUser;
  }

  get currentBoardUserId(): number {
    return this.currentBoardUser.id;
  }

  get userId() : number {
    return this.$store.state.AuthStore.user.id;
  }

  get isSameUser() : boolean {
    return this.currentBoardUserId === this.userId;
  }

  get isBoardSectionHomework() : boolean {
    return this.$store.state.CourseStore.isBoardSectionHomework;
  }

  get isShowSreenTeacher() : boolean {
    return (!this.isBoardSectionHomework || (this.isBoardSectionHomework && (this.isSameUser || !this.currentBoardUserId))) || !this.isPresentationModeTeacher;
  }

  /* Methods */
  goToSectionPreview({sectionId , courseId , classId = null, title = ''}: 
    { sectionId: number, courseId: number, classId?: number, title?: string}) : boolean {
    let selectInfo: IparamsComponentSelected = {
      courseId,
      classId, 
      componentInfo: { 
        name: this.componentName,
        section: null,
        edition: false
      }
    };
    let sections: Array<Section> = this.getCourseFromStore(
      {courseId, classId}
    ).sections;
    let section = SectionsProvider.getSectionByID(sections, sectionId);
    let parent = section ? SectionsProvider.getSectionByID(sections, section.parentId) : null;
    let response : boolean = false;    
    
    if(section && !((section.teacherOnly || (parent && parent.teacherOnly)) && this.isPresentationModeTeacher)) {
      let data = { sectionId, courseId, classId, title, type: section.type };
      this.updatePresentationModeViewerType(section.type);
        this.$Courses.Store.setPreviewSelected({ section , courseId , classId })
        this.goToComponentSelected(selectInfo);
        this.$edEventBus.$emit(COURSE_EVENTS.OBJECT_SELECTED, data);
        if(this.$store.state.AuthStore.role == KEYS.ROLES.PUBLISHER) {
          this.setTeacherPosition({...data, isFolder: false });
        }
        response = true;
        if(this.isPresentationModeTeacher){
          this.$edEventBus.$emit(COURSE_EVENTS.LOAD_PRESENTATION_COURSE_SECTION, data);
          this.validateTransparency(section);
          this.validateChangeSection();
        }
    }    
    return response;
  }

  private updatePresentationModeViewerType(sectionType: string): void {

    this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_PRESENTATION_MODE_VIEWER_TYPE, sectionType);

    let multipleTypes: string[] = [];
    if (SECTION_TYPES.LESSON_SPLIT_TYPE.code === sectionType) {
      multipleTypes = [SECTION_TYPES.LESSON_PDF.code, SECTION_TYPES.LESSON_SPLIT_TYPE.code];
    }

    this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_MULTIPLE_PRESENTATION_MODE_VIEWER_TYPES, multipleTypes);
  }

  private validateTransparency(section: Section) : void {
    if (this.validateBoardHomework(section)) {
      this.$edEventBus.$emit(ACTIVE_TRANSPARENCY_EVENT);
      return;
    }
    this.validateTransparencyManually();
  }

  private validateTransparencyManually() : void {
    if(this.isWhiteboardTransparency && !this.isTransparencyManually){
      this.$edEventBus.$emit(INACTIVE_TRANSPARENCY_EVENT);
    }
  }

  private validateChangeSection() : void {
    this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_CURRENT_BOARD_USER, {});
    this.$store.commit(HOMEWORKS_STORE.MUTATIONS.CLEAR_PRESENTATION_SECTION_CONTENT);
  }

  goToMaterialPreview({materialId , courseId , classId = null, title = ''}: 
    { materialId: number , courseId: number , classId?: number, title?: string }) : boolean {
      let selectInfo: IparamsComponentSelected = {
      courseId , 
      classId , 
      componentInfo: { 
        name: this.componentName , 
        section: null , 
        edition: false
     }
    };    
    let materials: any = this.getCourseFromStore({courseId, classId}).materials;
    let material = SectionsProvider.findCurrentCourseMaterial(materials , materialId);
    let response : boolean = false;
    
    if(material && !(material.data.teacherOnly && this.isPresentationModeTeacher)) {
      material.data.relatedContentId = materialId;
      let data = { materialId, classId, courseId, title, type: 'MATERIAL' };
      this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_PRESENTATION_MODE_VIEWER_TYPE, material.data.type);   
      this.$Courses.Store.setPreviewSelected(
        { material , courseId , classId }
      )
      this.goToComponentSelected(selectInfo);
      this.$edEventBus.$emit(COURSE_EVENTS.OBJECT_SELECTED, data);
      if(this.$store.state.AuthStore.role == KEYS.ROLES.PUBLISHER) {
        this.setTeacherPosition({
          sectionId: materialId,
          classId,
          courseId,
          isFolder: false
        });
      }
      if(this.isPresentationModeTeacher){
        this.$edEventBus.$emit(COURSE_EVENTS.LOAD_PRESENTATION_COURSE_SECTION, data);
        this.$Courses.Store.setIsBoardSectionHomework(false);
        this.validateTransparencyManually();
      }
      response = true;
    }
    return response;
  }

  goToProjectPreview({projectId , courseId , classId = null}: 
    { projectId: number, courseId: number, classId?: number}) : boolean {
    let selectInfo: IparamsComponentSelected = {
      courseId,
      classId, 
      componentInfo: { 
        name: this.componentName,
        section: null,
        edition: false
      }
    };
    let projects: Array<Project> = this.getCourseFromStore(
      {courseId, classId}
    ).projects;
    
    let project = SectionsProvider.getProjectByID(projects, projectId);
    let parent = project?.parentId ? SectionsProvider.getProjectByID(projects, project.parentId) : null;
    let response : boolean = false;

    if(project && !((project.section?.teacherOnly || (parent && parent.section?.teacherOnly)) && this.isPresentationModeTeacher)) {
      let data = { projectId, courseId, classId };
      this.$Courses.Store.setPreviewSelected(
        { project, courseId , classId }
      );
      this.goToComponentSelected(selectInfo);
      this.$edEventBus.$emit(COURSE_EVENTS.OBJECT_SELECTED, data);
      if(this.$store.state.AuthStore.role == KEYS.ROLES.PUBLISHER) {
        this.setTeacherPosition({
          sectionId: projectId,
          classId,
          courseId,
          isFolder: false
        });
      }
      response = true;
    }    
    return response;
  }

  goToComponentSelected(selectInfo: IparamsComponentSelected) {
    this.$Courses.Store.setComponentSelected(selectInfo)
    if(selectInfo.componentInfo.name !== this.componentName) {
      let objInfo = {
        materialId: null,
        sectionId: null,
        courseId: selectInfo.courseId, 
        classId: selectInfo.classId
      }
      this.$edEventBus.$emit(COURSE_EVENTS.OBJECT_SELECTED, objInfo);
    }
  }

  goToRefreshSectionsTree({ sectionId, parentId ,courseId, classId }: {
    sectionId: number, 
    parentId: number,
    courseId: number,
    classId: number
  }): Promise<void> {
    return new Promise((resolve , reject) => {
      this.getContentForCourse({courseId , classId}).then(() => {
        const div = document.getElementById(`${KEYS.PRE_OBJECT_ID}${sectionId}`);

        if (div) {   
          const { top } = div.getBoundingClientRect();

          ToolService.scrollTo(KEYS.ED_RESUME_TREE_ID, top);
          this.$edEventBus.$emit(COURSES_EVENTS.SECTION_SELECTED, { 
            sectionId: parentId
          });        
        }

        this.goToSectionPreview({ sectionId, courseId, classId });

        resolve();
      })
      .catch( err => reject(err));
    });
  }

  goToCreateObject(data: ICreateObjectParans) {
    this.$EdModal.createModal(
      SECTION_TYPES[data.code].modal, { 
        parentId: data.parentId,
        courseId: data.contentId,
        preload: data.preload,
        classId: data.classId,
        minDate: data.minDate,
        contentType: data.contentType || 'SUBJECT',
      }
    );
  }
  
  waitForReadyFileInfo(intervalId: number , fileData: any): Promise<number> {
    let course = this.getCourseFromStore({courseId: fileData.courseId , classId: fileData.classId});
    return new Promise((resolve, reject) => {
      if(fileData.sectionId) {
        this.$Courses.Store.updateCourseFilesIfInfoReadyA(fileData)
        .then((res) => {
          resolve(res.status);
          if(res.status != 206) {
            let previewInfo = {sectionId: fileData.sectionId , 
            courseId: fileData.courseId , classId: fileData.classId, title: fileData.title};
            clearInterval(intervalId);
            fileData.sectionId === course.viewer.sectionSelected.sectionId ?
            this.goToSectionPreview(previewInfo) : null;
            this.deleteFromStorage(fileData.sectionId , null);
          } 
        })
        .catch(() => reject());
      } else {
        this.$Courses.Store.updateCourseMaterialIfInfoReadyA(fileData)
        .then((res) => {
          resolve(res.status); 
          if(res.status != 206) {
            let previewInfo = {materialId: fileData.materialId , 
            courseId: fileData.courseId , classId: fileData.classId};
            clearInterval(intervalId);
            fileData.materialId === course.viewer.materialSelected.relatedContentId ? 
            this.goToMaterialPreview(previewInfo) : null;
            this.deleteFromStorage(null , fileData.materialId);
          }
        })
        .catch(() => reject());
      }
    });
  }

  checkStorage(sectionId: number , materialId: number): boolean {
    if(sectionId) {
      let  sectionIds: any[] = JSON.parse(localStorage.getItem('sectionIds'));
      let isCurrentSectionID: boolean = sectionIds ? sectionIds.includes(sectionId) : false;
      if(isCurrentSectionID) return false;
      else {
        sectionIds ? sectionIds.push(sectionId) : sectionIds = [sectionId];
        localStorage.setItem('sectionIds' , JSON.stringify(sectionIds));
        return true;
      }
    } else {
      let  materialIds: any[] = JSON.parse(localStorage.getItem('materialIds'));
      let isCurrentMaterialID: boolean = materialIds ? materialIds.includes(materialId) : false;
      if(isCurrentMaterialID) return false;
      else {
        materialIds ? materialIds.push(materialId) : materialIds = [materialId];
        localStorage.setItem('materialIds' , JSON.stringify(materialIds));
        return true;
      }
    }
  }

  deleteFromStorage(sectionId: number , materialId: number) {
    if(sectionId) {
      let  sectionIds: any[] = JSON.parse(localStorage.getItem('sectionIds'));
      if(sectionIds) {
        let index: number = sectionIds.indexOf(sectionId);
        sectionIds.splice(index , 1);
        localStorage.setItem('sectionIds' , JSON.stringify(sectionIds));
      }
    } else {
      let  materialIds: any[] = JSON.parse(localStorage.getItem('materialIds'));
      let index: number = materialIds.indexOf(materialId);
      materialIds.splice(index , 1);
      localStorage.setItem('materialIds' , JSON.stringify(materialIds));
    }
  }

  async getContentForCourse({courseId , classId = null,  isPurchasedTemplate = false}) {
    let isStudent = this.$store.state.AuthStore.role == KEYS.ROLES.BUYER;
    if(isStudent || isPurchasedTemplate) { 
      return await this.$Courses.Store.getContentForCourseA({
        courseId, classId
      });
    } else {
      return await this.$Courses.Store.getContentByEditorA({
        courseId, classId
      });
    }
  }

  /* Deprecated */
  getCoursesList(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.$Courses.Store.getCoursesA({
        classId: null
      })
      .then(() => {
        resolve();
      }).catch(() => {
        reject();
      });
    });
  }

  getCourseFromStore({courseId  , classId}: {courseId: number , classId?: number}): Course {
    let indexCourse: number = this.$store.state.CourseStore.courses.content.findIndex( (course: Course) => {
      if(classId) return course.id == courseId && course.classId == classId;
      else return course.id == courseId;
    });
    return this.$store.state.CourseStore.courses.content[indexCourse];
  }

  getSelectedTab(course , coursesTabSelected): boolean {
    let courseTab = JSON.stringify(this.setTabSelectedInfo(course));
    let currentTab = JSON.stringify(coursesTabSelected);
    return courseTab === currentTab;
  }

  isCourseLoaded(course , coursesLoaded) {
    let courseData = JSON.stringify(this.setTabSelectedInfo(course));
    let isLoaded = coursesLoaded.find((data) => JSON.stringify(data) === courseData);
    return isLoaded ? true : false;
  }

  setTabSelectedInfo(course) {
    return { name: course.title , 
    courseId: course.id , classId: course.classId}
  }

  async setTeacherPosition(
    { courseId, classId, sectionId, isFolder }: IParamsSetTeacherPosition) {
    let isTeacher = this.$store.state.AuthStore.role == KEYS.ROLES.PUBLISHER;
    if(classId && isTeacher) {
      let sectionID = sectionId;
      let course = this.$store.state.CourseStore
          .courses.content.find(c => c.id == courseId && c.classId == classId);
      if(course.mode !== COURSE_MODE.EDITION) {
        if(!sectionId && courseId) {
          if(course) {
            let section = course.viewer.sectionSelected;
            let material = course.viewer.materialSelected;
            sectionID = section ? section.id : material ? material.relatedContentId : 0;
          }
        }
        await this.$store.dispatch(_APP_STORE.ACTIONS.SEND_TEACHER_POSITION, {
          sectionId: sectionID,
          isFolder,
          classId,
          courseId,
        });
      }
    }
  }

  setCourseMaterialViewer(material: any): any {
    let mimeType = material?.data?.mimeType;
    if( !mimeType ) {
      mimeType = material.materialAssetInfo.mimeType;
      material.data = {
        contentFileUrl: material.materialAssetInfo.url
      }
    }
    material.isMultimediaFile = this.isMultimediaFile(mimeType);
    
    if(COURSE_MATERIAL_AUDIO_FILES_TYPES.includes(mimeType)) {
      return SECTION_TYPES.LESSON_MATERIAL.viewerAudioMaterial;
    }
    if(COURSE_MATERIAL_VIDEO_FILES_TYPES.includes(mimeType)) {
      return SECTION_TYPES.LESSON_MATERIAL.viewerVideoMaterial;
    }
    return SECTION_TYPES.LESSON_MATERIAL.viewer;
  }

  isMultimediaFile(mimeType) {
    let multimediaMimeTypeList = [...COURSE_MATERIAL_AUDIO_FILES_TYPES, ...COURSE_MATERIAL_VIDEO_FILES_TYPES];
    return multimediaMimeTypeList.includes(mimeType);
  }

  private isDraftResponseOption(section: Section): boolean {
    return (TYPE_BOARD_DRAFT_RESPONSE_OPTIONS.includes(section.type) || TYPE_TEXT_DRAFT_RESPONSE_OPTIONS.includes(section.type));
  }

  public validateBoardHomework(section : Section) : boolean{
    let isHomework: boolean = section.homework && this.isDraftResponseOption(section);
    this.$Courses.Store.setIsBoardSectionHomework(isHomework);
    return isHomework;
  }

}
